import React, { Component } from "react";
import { Card, Form, Row, Col, Button } from "react-bootstrap";
import AscModal from "../Modal/Modal";
import InlineForm from "../FromGroup/InlineForm";
import CommonTable from "../Table/CommonTable";
import ButtonSpeechBubble from "../AscElements/SetButtonWithSpeechBubble";
import { faMinus } from "@fortawesome/free-solid-svg-icons";
import "./NotificationSettingModal.css";

export default class NotificationSettingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailNotificationEnabled: props.emailNotificationEnabled !== undefined 
                ? props.emailNotificationEnabled : false,
            emailAddress: props.emailAddress || "",
            emailList: props.emailList || [],
            show: props.show || false,
            modalType: "setting",
            duplicateEmailError: false, // 重複メールアドレスエラー状態
            duplicateEmailList: [] // 重複メールアドレスリスト
        };
    }

    /**
     * メールアドレス重複チェック（単一メール用）
     */
    checkDuplicateEmail = (emailAddress) => {
        if (!emailAddress) return false;
        
        return this.state.emailList.some(email => 
            email.email_address.toLowerCase() === emailAddress.toLowerCase()
        );
    };

    /**
     * 複数メールアドレス重複チェック（セミコロン区切り対応）
     */
    checkMultipleEmailDuplication = (emailString) => {
        if (!emailString) return { hasDuplicate: false, duplicateEmails: [] };
        
        // セミコロン区切りでメールアドレスを分割
        const emailAddresses = emailString
            .split(';')
            .map(email => email.trim())
            .filter(email => email.length > 0);
        
        const duplicateEmails = [];
        const inputDuplicates = [];
        
        // 既存登録メールとの重複チェック
        emailAddresses.forEach(email => {
            if (this.checkDuplicateEmail(email)) {
                duplicateEmails.push(email);
            }
        });
        
        // 入力メール内での重複チェック
        const emailCounts = {};
        emailAddresses.forEach(email => {
            emailCounts[email.toLowerCase()] = (emailCounts[email.toLowerCase()] || 0) + 1;
        });
        
        Object.keys(emailCounts).forEach(email => {
            if (emailCounts[email] > 1) {
                // 既存重複でない場合のみ入力重複に追加
                if (!duplicateEmails.some(dupEmail => dupEmail.toLowerCase() === email)) {
                    inputDuplicates.push(email);
                }
            }
        });
        
        // 全重複メールを結合
        const allDuplicates = [...duplicateEmails, ...inputDuplicates];
        
        return {
            hasDuplicate: allDuplicates.length > 0,
            duplicateEmails: duplicateEmails,
            inputDuplicates: inputDuplicates,
            allDuplicates: allDuplicates
        };
    };

    /**
     * メール通知設定変更処理
     */
    handleEmailNotificationChange = (checked) => {
        this.setState({
            emailNotificationEnabled: checked
        });
    };

    /**
     * メールアドレス入力変更処理（セミコロン区切り複数メール対応）
     */
    handleEmailAddressChange = (e) => {
        const emailAddress = e.target.value;
        
        // セミコロン区切り複数メール重複チェック
        const duplicationResult = this.checkMultipleEmailDuplication(emailAddress);
        
        this.setState({
            emailAddress: emailAddress,
            duplicateEmailError: duplicationResult.hasDuplicate,
            duplicateEmailList: duplicationResult.allDuplicates // 全重複メールリスト保存
        });
    };

    /**
     * メール認証処理（セミコロン区切り複数メール対応）
     */
    handleEmailVerification = () => {
        if (!this.state.emailAddress.trim()) {
            alert(this.props.langText.Body.EmailAddressRequired);
            return;
        }
        
        // セミコロン区切りでメールアドレスを分割
        const emailAddresses = this.state.emailAddress
            .split(';')
            .map(email => email.trim())
            .filter(email => email.length > 0);
        
        // 入力メール内の重複チェック
        const emailCounts = {};
        const inputDuplicates = [];
        emailAddresses.forEach(email => {
            emailCounts[email.toLowerCase()] = (emailCounts[email.toLowerCase()] || 0) + 1;
        });
        
        Object.keys(emailCounts).forEach(email => {
            if (emailCounts[email] > 1) {
                inputDuplicates.push(email);
            }
        });
        
        // 入力内重複がある場合はエラー表示
        if (inputDuplicates.length > 0) {
            alert(this.props.langText.Message.EmailInputDuplicateError.replace('{0}', inputDuplicates.join('\n')));
            return;
        }
        
        // 各メールアドレスの既存登録重複チェック
        const duplicateEmails = [];
        const validEmails = [];
        
        emailAddresses.forEach(email => {
            if (this.checkDuplicateEmail(email)) {
                duplicateEmails.push(email);
            } else {
                // 簡単なメールアドレス形式チェック
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (emailRegex.test(email)) {
                    validEmails.push(email);
                }
            }
        });
        
        // 既存登録重複メールアドレスがあった場合はエラーメッセージ表示
        if (duplicateEmails.length > 0) {
            alert(this.props.langText.Message.EmailAlreadyRegisteredError.replace('{0}', duplicateEmails.join('\n')));
        }
        
        // 有効なメールアドレスがない場合
        if (validEmails.length === 0) {
            if (duplicateEmails.length === 0) {
                alert(this.props.langText.Message.EmailFormatError);
            }
            return;
        }
        
        // 新しいメールアドレスをテーブルに追加
        const newEmails = validEmails.map((email, index) => ({
            id: Date.now() + index, // 一時的なユニークID生成
            email_address: email,
            verification_status: 'unverified' // 初期値は未認証に設定
        }));
        
        this.setState({
            emailList: [...this.state.emailList, ...newEmails],
            emailAddress: "", // 入力フィールドを初期化
            duplicateEmailError: false, // エラー状態もリセット
            duplicateEmailList: [] // 重複メールリストもリセット
        });
        
        // 追加成功メッセージ
        if (validEmails.length > 1) {
            alert(this.props.langText.Message.EmailAddedSuccess.replace('{0}', validEmails.length));
        }
    };

    /**
     * メール削除処理（ローカルstateからのみ削除）
     */
    handleEmailDelete = (emailId) => {
        this.setState({
            emailList: this.state.emailList.filter(email => email.id !== emailId)
        });
    };

    /**
     * 設定保存処理
     */
    handleSave = () => {
        // サーバーAPI形式に合わせてデータ変換
        const row = this.state.emailList.map(email => ({
            address: email.email_address,
            status: email.verification_status === 'verified' ? 'Verified' : 'Unverified',
            type: 'mail'
        }));

        const settings = {
            row: row,
            mail_flag: this.state.emailNotificationEnabled === true // チェックボックス状態に応じてtrue/falseを明示的に設定
        };
        
        this.props.onSave(settings);
    };

    /**
     * バリデーション
     */
    validationHandle = () => {
        return true;
    };

    /**
     * プロップス更新時のstate同期
     */
    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show && this.props.show) {
            // モーダルが開かれる時にpropsで初期化
            this.setState({
                emailNotificationEnabled: this.props.emailNotificationEnabled !== undefined 
                    ? this.props.emailNotificationEnabled : false,
                emailAddress: this.props.emailAddress || "",
                emailList: this.props.emailList || [],
                duplicateEmailError: false, // エラー状態もリセット
                duplicateEmailList: [] // 重複メールリストもリセット
            });
        }
    }

    /**
     * メール登録状況テーブルのカラム定義
     */
    getEmailTableColumns = () => {
        const { langText } = this.props;
        return [
            {
                Header: langText.Body.EmailAddress,
                accessor: "email_address",
                width: 200
            },
            {
                Header: langText.Body.VerificationStatus,
                accessor: "verification_status",
                Cell: ({ value }) => (
                    <span className={value === 'verified' ? 'email-status-verified' : 'email-status-unverified'}>
                        {value === 'verified' ? langText.Body.Verified : langText.Body.Unverified}
                    </span>
                ),
                width: 120
            },
            {
                Header: langText.Body.Control,
                Cell: ({ row }) => (
                    <ButtonSpeechBubble
                        key={row.original.id + "_delete"}
                        size="sm"
                        className="control-button"
                        DisplayIcon={faMinus}
                        onClick={() => this.handleEmailDelete(row.original.id)}
                        speechBubble={[
                            <div key={row.original.id + "_delete_bubble"}>
                                {langText.Body.Delete}
                            </div>
                        ]}
                    />
                ),
                width: 80
            }
        ];
    };

    render() {
        const { langText } = this.props;

        return (
            <AscModal
                state={this.state}
                dialogClassName="notification-setting-modal"
                propSetState={(newState) => {
                    if (newState.show === false) {
                        // モーダルアニメーション用に事前にstateを変更
                        this.setState({ show: false });
                        // アニメーション完了後にpropsで初期化してonHide呼び出し
                        setTimeout(() => {
                            this.setState({
                                emailNotificationEnabled: this.props.emailNotificationEnabled !== undefined 
                                    ? this.props.emailNotificationEnabled : false,
                                emailAddress: this.props.emailAddress || "",
                                emailList: this.props.emailList || [],
                                duplicateEmailError: false, // エラー状態もリセット
                                duplicateEmailList: [] // 重複メールリストもリセット
                            });
                            this.props.onHide();
                        }, 150);
                    } else {
                        // モーダルが開かれる時はshowのみ更新
                        this.setState(newState);
                    }
                }}
                langText={langText}
                validationHandle={this.validationHandle}
                onClick={(modalType) => () => {
                    if (modalType === "setting") {
                        this.handleSave();
                    }
                }}
            >
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {langText.Body.ExternalNotification}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body>
                        {/* メール通知設定 */}
                        <InlineForm
                            key="email_notification_setting"
                            controlId="email_notification_setting"
                            label={langText.Body.EmailNotification}
                            labelCol={12}
                            formCol={12}
                        >
                            <Row className="mb-2 email-notification-checkbox-container">
                                <Col xs={12}>
                                    <Form.Check
                                        type="checkbox"
                                        id="email-notification-checkbox"
                                        label={langText.Body.EnableNotification}
                                        checked={this.state.emailNotificationEnabled}
                                        onChange={(e) => this.handleEmailNotificationChange(e.target.checked)}
                                        className="email-notification-checkbox"
                                    />
                                </Col>
                            </Row>

                            {this.state.emailNotificationEnabled && (
                                <>
                                    <Row className="mb-3">
                                        <Col xs={10}>
                                            <Form.Control
                                                type="email"
                                                placeholder={langText.Body.EmailAddressPlaceholder}
                                                value={this.state.emailAddress}
                                                onChange={this.handleEmailAddressChange}
                                                className={this.state.duplicateEmailError ? 'is-invalid' : ''}
                                            />
                                            {this.state.duplicateEmailError && (
                                                <div className="duplicate-email-error">
                                                    {this.state.duplicateEmailList.length > 0 
                                                        ? langText.Message.EmailDuplicateError.replace('{0}', [...new Set(this.state.duplicateEmailList)].join(', '))
                                                        : langText.Message.EmailAddressAlreadyRegistered
                                                    }
                                                </div>
                                            )}
                                        </Col>
                                        <Col xs={2}>
                                            <Button
                                                variant="primary"
                                                onClick={this.handleEmailVerification}
                                                disabled={!this.state.emailAddress.trim() || this.state.duplicateEmailError}
                                                className="add-button-style"
                                            >
                                                {langText.Body.Add}
                                            </Button>
                                        </Col>
                                    </Row>

                                    <div className="mb-4 notification-description">
                                        <p>{langText.Message.Notification_Setting_Alarm_Content_Notice}</p>
                                        <p>{langText.Message.Notification_Setting_Email_Auth_Notice}</p>
                                        <p>{langText.Message.Notification_Setting_Multiple_Email_Notice}</p>
                                    </div>
                                </>
                            )}
                        </InlineForm>

                        {/* メール登録状況 */}
                        <InlineForm
                            key="email_registration_status"
                            controlId="email_registration_status"
                            label={langText.Body.EmailRegistrationStatus}
                            labelCol={12}
                            formCol={12}
                        >
                            <CommonTable
                                columns={this.getEmailTableColumns()}
                                data={this.state.emailList}
                                showPagination={false}
                                defaultPageSize={10}
                                minRows={3}
                                className="email-registration-table"
                                langText={langText && langText.Table ? langText.Table : {}}
                            />
                        </InlineForm>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
} 